<template>
    <transition name="fade">
        <!-- Dimmer -->
        <div
            v-if="visible"
            class="flex-1 flex items-center justify-center flex-col bg-white bg-opacity-50 active:outline-none z-50 fixed inset-0 "
        >
            <!-- style="backdrop-filter: blur(10px);" -->
            <div class="loading-animation">
                <div />
                <div />
                <div />
            </div>
            <p class="text-base font-bold text-gray-700 tracking-wide">
                {{ text }}
            </p>
        </div>
    </transition>
</template>
<script>
import { ref, watchEffect } from 'vue';
import { enableScroll, disableScroll } from '@/utils/style/fixedBodyScroll';

export default {
    name: 'Loading',
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
        text: {
            type: String,
            default: 'LOADING...',
        }
    },
    setup(props) {
        //     const isLoading = ref(false);
        //     bus.$on('loading', (data) => {
        //         isLoading.value = data;
        //         console.log('loading', data);
        //     });
        //     onBeforeUnmount(() => {
        //         // 銷毁監聽
        //         bus.$off('loading');
        //     });
        const visible = ref(false);

        watchEffect(() => {
            visible.value = props.isLoading;
            visible.value ? disableScroll() : enableScroll();
        });

        return { visible };
    },
};
</script>
<style lang="scss" scoped>
.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active {
    animation: opacity-in 0.25s;
}
.fade-leave-active {
    animation: opacity-in 0.25s reverse;
}
@keyframes opacity-in {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.loading-animation {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 75px;
}
.loading-animation div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: linear-gradient(-110deg, #0089d1, #01b6ad);
    opacity: 0.9;
    animation: loading-animation 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.loading-animation div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
}
.loading-animation div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
}
.loading-animation div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
}
@keyframes loading-animation {
    0% {
        top: 8px;
        height: 72px;
    }
    50%,
    100% {
        top: 24px;
        height: 36px;
    }
}
</style>
